module.exports = __webpack_public_path__ + "static/media/Rainbow_Sunny_Partly_Calm.2aa99d3b.gif";